/* Môj TAMITOS in the shop (v12). One state fetch from tamitos.com drives the
   header pill, the row in the mobile menu, the TAMI block in the cart and the
   points dialog. tamitos.com and shop.tamitos.com are the same site, so the
   member cookie travels with a credentialed fetch. The POST is text/plain: no
   preflight. Change addresses and the return parameter name in CFG only. */
(function () {
  if (window.TAMI) return;
  var CFG = {
    api: 'https://tamitos.com/dashboard/obchod',
    login: 'https://tamitos.com/dashboard/prihlasenie',
    dash: 'https://tamitos.com/dashboard',
    ret: 'spat',      /* return address parameter understood by tamitos.com */
    step: 500,        /* smallest exchange, in TAMI */
    stepEur: 5,       /* what the smallest exchange is worth */
    earnPer10: 50     /* TAMI earned for every 10 EUR spent */
  };
  if (window.TAMI_CFG) for (var k in window.TAMI_CFG) CFG[k] = window.TAMI_CFG[k];

  var pill = document.querySelector('[data-tami-pill]');
  var dlg = document.querySelector('[data-tami-dlg]');
  var en = pill ? pill.getAttribute('data-lang') === 'en' : /^en/.test(document.documentElement.lang);
  var COIN = '<span class="tp-coin" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 2.8l2.6 5.6 6.1.7-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6L3.3 9.1l6.1-.7z"/></svg></span>';
  var T = en ? {
    eye: 'My TAMITOS', sub: 'Your TAMI points. Turn them into a discount for this order.',
    dash: 'Open My TAMITOS', off: 'For {p} TAMI', eur: '{e} € off', min: 'order from {m} €',
    soon: 'Exchanging points for a discount starts very soon. Your points are safe.',
    busy: 'Creating your code…', done: 'Your code {c} is ready. We are adding it to your cart.',
    err: { balance: 'Not enough points.', signin: 'Please sign in again.', shopify: 'The code could not be created, your points are back. Please try again.', off: 'Exchanging points is not switched on yet.' },
    fail: 'Something went wrong. Please try again.',
    hint: 'Collect TAMI points', mine: 'Your points and discounts',
    have: 'You have {n} TAMI', unlock: 'Unlock {e} € off at {s} TAMI',
    left: '{r} TAMI to go.', thisOrder: 'This order earns you <b>{x} TAMI</b>.',
    reach: 'After this order you will have <b>{t} TAMI</b>, enough for {e} € off.',
    ways: 'You earn TAMI with every order (50 TAMI for every 10 €), in the TAMITOS Move app and in our games.',
    more: 'How to earn more TAMI', canHead: 'Turn them into a discount on this order',
    canBtn: 'Get up to {e} € off', outHead: 'This order earns you {x} TAMI',
    outZero: 'Collect TAMI points', outSub: 'Sign in and collect TAMI points. At {s} TAMI you get {e} € off.',
    outSub0: 'You get 50 TAMI for every 10 € you spend. At {s} TAMI you get {e} € off.',
    outBtn: 'Sign in and collect',
    subLow: 'Collect TAMI points. At {s} TAMI you can swap them for a discount.'
  } : {
    eye: 'Môj TAMITOS', sub: 'Tvoje TAMI body. Vymeň ich za zľavu na tento nákup.',
    dash: 'Otvoriť Môj TAMITOS', off: 'Za {p} TAMI', eur: 'zľava {e} €', min: 'pri nákupe od {m} €',
    soon: 'Výmenu bodov za zľavu spúšťame už čoskoro. Tvoje body sú v bezpečí.',
    busy: 'Vytváram tvoj kód…', done: 'Tvoj kód {c} je pripravený. Pridávame ho do košíka.',
    err: { balance: 'Nemáš dosť bodov.', signin: 'Prihlás sa prosím znova.', shopify: 'Kód sa nepodarilo vytvoriť, body sú späť. Skús to prosím znova.', off: 'Výmena bodov ešte nie je zapnutá.' },
    fail: 'Niečo sa pokazilo. Skús to prosím znova.',
    hint: 'Zbieraj TAMI body', mine: 'Tvoje body a zľavy',
    have: 'Máš {n} TAMI', unlock: 'Zľavu {e} € odomkneš pri {s} TAMI',
    left: 'Chýba ti {r} TAMI.', thisOrder: 'Za tento nákup získaš <b>{x} TAMI</b>.',
    reach: 'Po tomto nákupe budeš mať <b>{t} TAMI</b>, to stačí na zľavu {e} €.',
    ways: 'Body získaš za každý nákup (50 TAMI za každých 10 €), v appke TAMITOS Move a v našich hrách.',
    more: 'Ako získať viac TAMI', canHead: 'Vymeň ich za zľavu na tento nákup',
    canBtn: 'Uplatniť zľavu až {e} €', outHead: 'Za tento nákup získaš {x} TAMI',
    outZero: 'Zbieraj TAMI body', outSub: 'Prihlás sa a zbieraj TAMI body. Pri {s} TAMI máš zľavu {e} €.',
    outSub0: 'Za každých 10 € nákupu získaš 50 TAMI. Pri {s} TAMI máš zľavu {e} €.',
    outBtn: 'Prihlásiť sa a zbierať',
    subLow: 'Zbieraj TAMI body. Pri {s} TAMI ich vymeníš za zľavu.'
  };

  var state = null, cartCents = null;
  function fmt(n) { return String(Math.max(0, Math.floor(Number(n) || 0))).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function fill(s, o) { return s.replace(/\{(\w)\}/g, function (_, k) { return o[k]; }); }
  function step() { return Number(state && state.step) || CFG.step; }
  function earn(c) { return Math.floor((Number(c) || 0) / 1000) * CFG.earnPer10; }
  function loginUrl() {
    var u;
    try { u = new URL((state && state.login) || CFG.login); } catch (e) { u = new URL(CFG.login); }
    u.searchParams.set(CFG.ret, location.href);
    if (en && !u.searchParams.has('lang')) u.searchParams.set('lang', 'en');
    return u.toString();
  }
  function dashUrl() { return (state && state.dashboard) || (CFG.dash + (en ? '/en' : '')); }
  function signedIn() { return !!(state && state.signed_in); }

  /* header pill */
  function paintPill() {
    if (!pill) return;
    if (!pill.querySelector('.tp-coin')) {
      var old = pill.querySelector('.tp-star');
      var c = document.createElement('span');
      c.innerHTML = COIN;
      if (old) old.replaceWith(c.firstChild); else pill.insertBefore(c.firstChild, pill.firstChild);
    }
    var n = pill.querySelector('.tp-n');
    if (!n) { n = document.createElement('b'); n.className = 'tp-n'; pill.appendChild(n); }
    if (signedIn()) {
      n.innerHTML = '<span></span><i> TAMI</i>';
      n.firstChild.textContent = fmt(state.balance);
      n.hidden = false;
      pill.classList.add('on');
      pill.href = dashUrl();
      pill.title = T.eye + ': ' + fmt(state.balance) + ' TAMI';
    } else {
      n.hidden = true;
      pill.classList.remove('on');
      pill.href = loginUrl();
      pill.title = T.eye + ': ' + T.hint;
    }
    pill.setAttribute('aria-label', pill.title);
    document.dispatchEvent(new CustomEvent('v12:fit'));
  }

  /* the Môj TAMITOS row at the top of the mobile menu */
  function paintMenu() {
    var m = document.querySelector('[data-tami-pill-m]');
    if (!m) return;
    if (!m.classList.contains('v12-mrow')) {
      m.classList.add('v12-mrow');
      m.innerHTML = COIN + '<span class="v12-mrow-t"><b></b><small></small></span><span class="tp-n" hidden></span>';
      var top = document.querySelector('.mnav-in');
      if (top) top.insertBefore(m, top.firstChild);
    }
    m.querySelector('b').textContent = T.eye;
    var n = m.querySelector('.tp-n');
    if (signedIn()) {
      m.querySelector('small').textContent = T.mine;
      n.innerHTML = '<span></span><i> TAMI</i>';
      n.firstChild.textContent = fmt(state.balance);
      n.hidden = false;
      m.href = dashUrl();
    } else {
      m.querySelector('small').textContent = T.hint;
      n.hidden = true;
      m.href = loginUrl();
    }
  }

  /* the TAMI block: cart summary and dialog share it */
  function cartTotal() {
    if (cartCents != null) return cartCents;
    var el = document.querySelector('.cart-sum .cart-total');
    if (!el) return 0;
    var v = el.textContent.replace(/[^\d.,]/g, '');
    v = /,\d{1,2}$/.test(v) ? v.replace(/\./g, '').replace(',', '.') : v.replace(/,/g, '');
    return Math.round(parseFloat(v) * 100) || 0;
  }
  function block(box, where) {
    var s = state, st = step(), eur = CFG.stepEur, x = document.querySelector('.cart-sum') ? earn(cartTotal()) : 0;
    var h = '';
    if (!signedIn()) {
      h = '<div class="v12-tami-h">' + COIN + '<div><b></b><span class="v12-ts"></span></div></div>' +
        '<div class="v12-tami-a"><a class="v12-tbtn" data-login></a></div>';
      box.innerHTML = h;
      box.querySelector('b').textContent = x ? fill(T.outHead, { x: fmt(x) }) : T.outZero;
      box.querySelector('.v12-tami-h .v12-ts').textContent = fill(x ? T.outSub : T.outSub0, { s: fmt(st), e: eur });
      var a = box.querySelector('[data-login]');
      a.textContent = T.outBtn;
      a.href = loginUrl();
      return;
    }
    var bal = Number(s.balance) || 0;
    var can = s.can_spend && s.options && s.options.length;
    if (can) {
      box.innerHTML = '<div class="v12-tami-h">' + COIN + '<div><b></b><span class="v12-ts"></span></div></div>' +
        (where === 'cart' ? '<div class="v12-tami-a"><button type="button" class="v12-tbtn" data-open></button></div>' : '');
      box.querySelector('b').textContent = fill(T.have, { n: fmt(bal) });
      box.querySelector('.v12-tami-h .v12-ts').textContent = T.canHead;
      var b = box.querySelector('[data-open]');
      if (b) { b.textContent = fill(T.canBtn, { e: s.options[s.options.length - 1].eur }); b.addEventListener('click', openDlg); }
      return;
    }
    var p = Math.min(100, bal / st * 100), q = Math.min(100, (bal + x) / st * 100);
    var line = bal >= st ? T.soon : (x && bal + x >= st ? fill(T.reach, { t: fmt(bal + x), e: eur })
      : fill(T.left, { r: fmt(st - bal) }) + (x ? ' ' + fill(T.thisOrder, { x: fmt(x) }) : ''));
    box.innerHTML = '<div class="v12-tami-h">' + COIN + '<div><b></b><span class="v12-ts"></span></div></div>' +
      '<div class="v12-prog" role="progressbar" aria-valuemin="0" aria-valuemax="' + st + '" aria-valuenow="' + Math.min(bal, st) + '">' +
      '<em style="--q:' + q.toFixed(1) + '%"></em><i style="--p:' + p.toFixed(1) + '%"></i></div>' +
      '<div class="v12-prog-l"><span>0</span><span>' + fmt(st) + ' TAMI = ' + eur + ' €</span></div>' +
      '<p class="v12-tami-s">' + line + '</p>' +
      '<p class="v12-tami-s" data-ways></p>' +
      '<div class="v12-tami-a"><a class="v12-tlink" data-dash></a></div>';
    box.querySelector('b').textContent = fill(T.have, { n: fmt(bal) });
    box.querySelector('.v12-tami-h .v12-ts').textContent = fill(T.unlock, { e: eur, s: fmt(st) });
    box.querySelector('[data-ways]').textContent = T.ways;
    var d = box.querySelector('[data-dash]');
    d.textContent = T.more;
    d.href = dashUrl();
  }
  function paintCart() {
    var sum = document.querySelector('.cart-sum');
    if (!sum) return;
    var old = sum.querySelector('[data-tami-cart]');
    if (old) old.hidden = true;
    var box = sum.querySelector('.v12-tami');
    if (!box) {
      box = document.createElement('div');
      box.className = 'v12-tami';
      box.setAttribute('aria-live', 'polite');
      var at = sum.querySelector('.ship-meter') || sum.querySelector('[name="checkout"]');
      sum.insertBefore(box, at || null);
    }
    if (!state) { box.setAttribute('data-state', 'loading'); return; }
    box.removeAttribute('data-state');
    block(box, 'cart');
  }

  /* the points dialog */
  function render() {
    if (!dlg) return;
    dlg.querySelector('[data-bal]').textContent = fmt(state.balance);
    var body = dlg.querySelector('[data-body]');
    body.innerHTML = '';
    var low = !(state.can_spend && state.options && state.options.length);
    var sub = dlg.querySelector('[data-t="sub"]');
    if (sub) sub.textContent = low ? fill(T.subLow, { s: fmt(step()) }) : T.sub;
    if (low) {
      var box = document.createElement('div');
      box.className = 'v12-tami';
      body.appendChild(box);
      block(box, 'dlg');
      return;
    }
    var list = document.createElement('div');
    list.className = 'td-opts';
    state.options.slice(0, 6).forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'td-opt';
      b.innerHTML = '<b></b><span></span><small></small>';
      b.children[0].textContent = fill(T.eur, { e: o.eur });
      b.children[1].textContent = fill(T.off, { p: fmt(o.points) });
      b.children[2].textContent = fill(T.min, { m: o.min_order });
      b.addEventListener('click', function () { spend(o.points, b); });
      list.appendChild(b);
    });
    body.appendChild(list);
    var msg = document.createElement('p');
    msg.className = 'td-msg';
    msg.setAttribute('role', 'status');
    body.appendChild(msg);
  }
  function spend(points, btn) {
    var msg = dlg.querySelector('.td-msg');
    [].forEach.call(dlg.querySelectorAll('.td-opt'), function (b) { b.disabled = true; });
    if (btn) btn.classList.add('is-busy');
    msg.className = 'td-msg';
    msg.textContent = T.busy;
    fetch(CFG.api + '/zlava', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ points: points }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (x.ok && x.j.apply_url) {
          msg.classList.add('ok');
          msg.textContent = fill(T.done, { c: x.j.code });
          setTimeout(function () { location.href = x.j.apply_url; }, 700);
          return;
        }
        throw (x.j && T.err[x.j.error]) || T.fail;
      })
      .catch(function (e) {
        msg.classList.add('bad');
        msg.textContent = typeof e === 'string' ? e : T.fail;
        if (btn) btn.classList.remove('is-busy');
        [].forEach.call(dlg.querySelectorAll('.td-opt'), function (b) { b.disabled = false; });
      });
  }
  function openDlg(e) {
    if (!signedIn() || !dlg || !dlg.showModal) return;
    if (e) e.preventDefault();
    render();
    if (!dlg.open) dlg.showModal();
  }

  function apply(s) {
    state = s || { signed_in: false };
    if (dlg) {
      var dash = dlg.querySelector('[data-dash]');
      if (dash) dash.href = dashUrl();
    }
    paintPill();
    paintMenu();
    paintCart();
    try { sessionStorage.setItem('tami:v12', JSON.stringify({ t: Date.now(), signed_in: !!state.signed_in, balance: state.balance || 0 })); } catch (e) {}
  }

  if (dlg) {
    [].forEach.call(dlg.querySelectorAll('[data-t]'), function (el) { el.textContent = T[el.getAttribute('data-t')]; });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }
  if (pill) pill.addEventListener('click', openDlg);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-tami-pill-m]')) openDlg(e); });
  /* the cart was changed without a reload: refresh the block */
  document.addEventListener('v12:cart', function (e) { if (e.detail && e.detail.total_price != null) cartCents = e.detail.total_price; paintCart(); });

  /* paint straight away from the last known balance, so nothing jumps, then refresh */
  try {
    var c = JSON.parse(sessionStorage.getItem('tami:v12') || 'null');
    if (c && Date.now() - c.t < 600000) apply({ signed_in: c.signed_in, balance: c.balance, cached: true });
    else { paintPill(); paintMenu(); paintCart(); }
  } catch (e) { paintPill(); paintMenu(); paintCart(); }

  if (window.fetch) {
    fetch(CFG.api + '/stav' + (en ? '?lang=en' : ''), { credentials: 'include', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () { if (!state) apply({ signed_in: false }); });
  }

  window.TAMI = { cfg: CFG, apply: apply, open: openDlg, state: function () { return state; } };
})();
